const files = require.context('.', true, /\.js$/)
const logic = {}

files.keys().forEach((key) => {
  if (key === './index.js' || key === './config.js' || key === './logic.js' || key === './answer.js' || key === './validate.js' ||
  key === './answerValidate.js') {
    return
  }
  if (key.indexOf('logic') > -1) {
    logic[key.substring(key.indexOf('/') + 1, key.lastIndexOf('/'))] = files(key).default
  }
})
export default logic



// WEBPACK FOOTER //
// ./src/components/editor/logic.js